// src/pages/bloomterminal/alerts/components/PageTitle.jsx
import React from 'react';
import { useGlobalFontSize } from '../../../context/GlobalFontSizeContext';

const PageTitle = ({ title }) => {
  const { fontSize } = useGlobalFontSize();
  return (
    <div className="flex flex-col gap-4 items-center w-full">
      <h1 
        className="font-['Inter'] font-medium text-bloom-green text-center"
        style={{ fontSize: fontSize + 10 }}
      >
        {title}
      </h1>
    </div>
  );
};

export default PageTitle;

